import { StyleSheet } from 'react-native';

export const USER_IMAGE_WIDTH = 32;

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: -5,
    },
    svgButton: {
        width: 34,
        padding: 5,
        aspectRatio: 1,
        alignItems: 'center',
        justifyContent: 'center',
        // @ts-ignore
        cursor: 'pointer',
    },
    searchIcon: {
        width: 20,
        height: 20,
    },
    svgUserButtonMarginLeft: {
        marginLeft: 5,
    },
    userIcon: {
        width: USER_IMAGE_WIDTH,
        height: USER_IMAGE_WIDTH,
        borderRadius: USER_IMAGE_WIDTH,
    },
    castButton: {
        width: 24,
        height: 24,
        marginRight: 12,
    },
});

export default styles;
